import styled from 'styled-components';

export const InputWithAdornmentWrapper = styled.div`
  display: flex;
  gap: 6px;

  &&& .isReadOnly .MuiInputBase-root {
    opacity: 1;

    .MuiInputBase-input {
      color: #8a8a8a;
      font-family: Lato;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }
  }

  .MuiInputBase-input {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const TooltipContent = styled.div`
  text-align: center;
`;
